/**
 * GoogleServicesService — wraps CCMS.Api.GoogleServices.
 *
 * Public surface for the Google Maps integration. The microservice itself
 * caches results aggressively in Redis, so calling these from the frontend
 * is safe and cheap. The Google API key never leaves the server.
 *
 * Route prefix: `/google-services/api/google/*` (servicePath = "google-services")
 */
import { BaseService } from '../base';
export class GoogleServicesService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? GoogleServicesService.DEFAULT_SERVICE_PATH,
            basePath: 'api/google',
            endpoints: config?.endpoints,
        });
    }
    async geocode(address) {
        const url = this.buildUrl('geocode');
        const resp = await this.http.post(url, { Address: address });
        return resp.data ?? null;
    }
    async reverseGeocode(latitude, longitude) {
        const url = this.buildUrl('geocode/reverse');
        const resp = await this.http.post(url, { Latitude: latitude, Longitude: longitude });
        return resp.data ?? null;
    }
    async distance(origin, destination) {
        const url = this.buildUrl('distance');
        const resp = await this.http.post(url, {
            Origin: origin,
            Destination: destination,
        });
        return resp.data ?? null;
    }
    async autocomplete(query, sessionToken) {
        const tokenSegment = sessionToken ? `&sessionToken=${encodeURIComponent(sessionToken)}` : '';
        const url = this.buildUrl(`places/autocomplete?q=${encodeURIComponent(query)}${tokenSegment}`);
        const resp = await this.http.get(url);
        return resp.data ?? [];
    }
    async directions(originLat, originLng, destLat, destLng) {
        const url = this.buildUrl('directions');
        const resp = await this.http.post(url, {
            OriginLat: originLat, OriginLng: originLng,
            DestLat: destLat, DestLng: destLng,
        });
        return resp.data ?? null;
    }
}
GoogleServicesService.DEFAULT_SERVICE_PATH = 'google-services';
//# sourceMappingURL=GoogleServicesService.js.map